export const INFO = {
  'mangrove_extent': [
    {
      id: 1,
      title: 'GMW Mangrove Extent 1996 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw1996v2_0.tif',
      description: 'Polygon data depicting the the areal extent of mangrove habitat for the year 1996. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 2,
      title: 'GMW Mangrove Extent 2007 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2007v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2007. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 3,
      title: 'GMW Mangrove Extent 2008 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2008v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2008. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 4,
      title: 'GMW Mangrove Extent 2009 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2009v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2009. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 5,
      title: 'GMW Mangrove Extent 2010 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2010v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2010. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 6,
      title: 'GMW Mangrove Extent 2011 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2011v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2011. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 7,
      title: 'GMW Mangrove Extent 2015 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2015v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2015. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
    {
      id: 8,
      title: 'GMW Mangrove Extent 2016 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2016v2_0.tif',
      description: 'Polygon data depicting the areal extent of mangrove habitat for the year 2016. The data set was generated by Aberystwyth University and soloEO within the framework of the Global Mangrove Watch (GMW) project, which is a part of the Japan Aerospace Exploration Agency’s (JAXA) Kyoto & Carbon Initiative and the Mangrove Capital Africa Programme coordinated by Wetlands International and financed by DOB Ecology.',
      license: 'Attribution 4.0 International (CC BY 4.0)',
    },
  ],
  'mangrove_net_change': [
    {
      id: 9,
      title: 'GMW Mangrove Extent 1996 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw1996v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 10,
      title: 'GMW Mangrove Extent 2007 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2007v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 11,
      title: 'GMW Mangrove Extent 2008 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2008v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 12,
      title: 'GMW Mangrove Extent 2009 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2009v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 13,
      title: 'GMW Mangrove Extent 2010 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2010v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 14,
      title: 'GMW Mangrove Extent 2011 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2011v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 15,
      title: 'GMW Mangrove Extent 2015 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2015v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
    {
      id: 16,
      title: 'GMW Mangrove Extent 2016 v2',
      href: 'https://storage.googleapis.com/mangrove_atlas/land-cover/gmw2016v2_0.tif',
      description: 'Raster depicting areas of mangrove gain and loss'
    },
  ],
  'mangrove_alerts': [
    {
      id: 17,
      title: 'Mangrove Alerts',
      href: false,
      description: false
    },
  ],
  'mangrove_blue_carbon': [
    {
      id: 18,
      title: 'Mangrove Blue Carbon (Total)',
      href: 'https://console.cloud.google.com/storage/browser/mangrove_atlas/ee_export_tiffs/total_organic_carbon?pageState=(%22StorageObjectListTable%22:(%22f%22:%22%255B%255D%22))&prefix=&forceOnObjectsSortingFiltering=false',
    },
    {
      id: 19,
      title: 'Mangrove Soil Carbon',
      href: 'https://zenodo.org/record/2536803#.YP6xOuhKg2x',
      description: false,
      license: 'Creative Commons Attribution Share Alike 4.0 International',
    },
    // {
    //   id: 20,
    //   title: 'Mangrove Aboveground Carbon',
    //   href: null,
    //   description: false
    // },
  ],
  // 'mangrove_protection': [

  // ],
  'mangrove_height': [
    {
      id: 21,
      title: 'Mangrove Height',
      href: 'https://daac.ornl.gov/CMS/guides/CMS_Global_Map_Mangrove_Canopy.html',
      description: 'External link to download mangrove height data from source (NASA)'
    },
  ],
  'mangrove_biomass': [
    {
      id: 22,
      title: 'Mangrove Biomass',
      href: 'https://daac.ornl.gov/CMS/guides/CMS_Global_Map_Mangrove_Canopy.html',
      description: 'External link to download mangrove biomass data from source (NASA)'
    },
  ]
};

export default { INFO };
